import MimirService from '../services/mimir-service';

import {
    FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST,
    FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS,
    FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE,
    FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_REQUEST,
    FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_SUCCESS,
    FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_FAILURE,
    FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST,
    FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS,
    FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE,
} from './types/domains-with-counts-action-types';

import {
    DOMAIN_HIERARCHY_PARENT,
    DOMAIN_HIERARCHY_SUBDOMAIN,
    DOMAIN_STATUS_UNCLAIMED,
} from '../../common/constants/definitions';

// Unclaimed Parent Domains
function fetchUnclaimedParentDomainsWithCountsRequest( params = {} ){
    return {
        params,
        type: FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST,
    };
}
function fetchUnclaimedParentDomainsWithCountsSuccess( { byId, allIds, pagination } ){
    return {
        allIds,
        byId,
        pagination,
        type: FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS,
    };
}
function fetchUnclaimedParentDomainsWithCountsFailure( error ){
    return {
        error,
        type: FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE,
    };
}

// Claimed Parent Domains
function fetchClaimedParentDomainsWithCountsRequest( params = {}, filters = {}  ){
    return {
        filters,
        params,
        type: FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST,
    };
}
function fetchClaimedParentDomainsWithCountsSuccess( { byId, allIds, pagination } ){
    return {
        allIds,
        byId,
        pagination,
        type: FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS,
    };
}
function fetchClaimedParentDomainsWithCountsFailure( error ){
    return {
        error,
        type: FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE,
    };
}

// Claimed Subdomains
function fetchClaimedSubdomainsWithCountsRequest( params = {}, filters = {} ){
    return {
        filters,
        params,
        type: FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_REQUEST,
    };
}
function fetchClaimedSubdomainsWithCountsSuccess( { byId, allIds, pagination } ){
    return {
        allIds,
        byId,
        pagination,
        type: FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_SUCCESS,
    };
}
function fetchClaimedSubdomainsWithCountsFailure( error ){
    return {
        error,
        type: FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_FAILURE,
    };
}

const fetchDomainsMap = {
    [DOMAIN_HIERARCHY_PARENT]: {
        failure: fetchClaimedParentDomainsWithCountsFailure,
        request: fetchClaimedParentDomainsWithCountsRequest,
        success: fetchClaimedParentDomainsWithCountsSuccess,
    },
    [DOMAIN_HIERARCHY_SUBDOMAIN]: {
        failure: fetchClaimedSubdomainsWithCountsFailure,
        request: fetchClaimedSubdomainsWithCountsRequest,
        success: fetchClaimedSubdomainsWithCountsSuccess,
    },
    [DOMAIN_STATUS_UNCLAIMED]: {
        failure: fetchUnclaimedParentDomainsWithCountsFailure,
        request: fetchUnclaimedParentDomainsWithCountsRequest,
        success: fetchUnclaimedParentDomainsWithCountsSuccess,
    },
};

export function fetchDomainsWithCounts( params, filters = {} ){
    return ( dispatch, getState, { DATA_API } ) => {
        const { domainHierarchy, domainStatus } = params;

        const isUnclaimedDomain = domainStatus && domainStatus === DOMAIN_STATUS_UNCLAIMED;
        const domainsMapType = isUnclaimedDomain ? DOMAIN_STATUS_UNCLAIMED : domainHierarchy;

        const fetch = fetchDomainsMap[domainsMapType];

        dispatch( fetch.request.call( this, params, filters ) );

        const api = new MimirService( DATA_API );
        const finalParams = {
            ...params,
            ...filters
        };

        return api.getDomainsWithCounts( finalParams ).then(
            ( response ) => {
                dispatch( fetch.success.call( this, response ) );
            },
            ( error ) => dispatch( fetch.failure.call( this, error ) )
        );
    };
}
